import { Directive, ElementRef, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from 'AuthService';
import { Roles } from '@helper/enums/roles.enum';

@Directive({
    selector: '[userRoleNeeded_disabled]',
    standalone: false
})
export class UserRoleNeededDisabledDirective   {

  constructor(
    private el: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) { }

  @Input()
  set userRoleNeeded_disabled(val) {

    if (!val) {
      console.warn('Konnte Rollen nicht lesen!');
      return;
    }

    const _neededRoles: Roles[] = [];

    const rn = val.split(',').map(x => x.trim());


    for (let i = 0; i < rn.length; i++) {
      const role = Roles[rn[i]] as Roles;
      if (role) {
        _neededRoles.push(role);
      }
      else {
        throw new Error('Konnte \'' + rn[i] + '\' keiner vorhandenen Zugriffsbeschränkung zuordnen!');
      }
    }

    if (_neededRoles && _neededRoles.length > 0) {
      if (this.authService.hasOneRole(_neededRoles)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
      else {
        this.viewContainer.clear();
      }
    }
  }
}
